import { Component, OnInit, Optional, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { LanguageService } from 'src/app/services';
import * as _ from 'lodash';

@Component({
  selector: 'esc-role-maintenance-filter',
  templateUrl: './role-maintenance-filter.component.html',
  styleUrls: ['./role-maintenance-filter.component.scss']
})
export class RoleMaintenanceFilterComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    public media: MediaObserver,
    private languageService: LanguageService,
    public dialogRef: MatDialogRef<RoleMaintenanceFilterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public loading = {
    status: false,
    error: false
  };

  statuses = [
    {
      code: null,
      description: "All",
    },
    {
      code: 1,
      description: "Active",
    },
    {
      code: 0,
      description: "Inactive",
    },
  ];
  public filters;

  public formGroup: FormGroup;
  networkErrMsg = this.languageService.getTranslation("MESSAGE_ERROR_NETWORK_CONNECTION", {});

  ngOnInit() {
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
  }

  initForm() {
    this.formGroup = this.fb.group({
      status: [_.get(this.data, 'status') || this.statuses[0], Validators.required]
    })
  }
  
  compareWithFunc = (a: any, b: any) => (a && b) ? a.code == b.code : null;

  resetControl(control: FormControl) {
    control.reset(null, { emitEvent: false });
  }

  applyFilters() {
    for (let ctrl in this.formGroup.controls) {
      if(!this.formGroup.controls[ctrl].valid) {
        this.formGroup.controls[ctrl].markAsTouched();
      }
    }

    if(this.formGroup.valid) {
      this.dialogRef.close(this.formGroup.value);
    }
  }

  reset() {
    for(let ctrl in this.formGroup.controls) {
      this.formGroup.controls[ctrl].reset(null, {emitEvent: false});
      this.formGroup.controls[ctrl].markAsUntouched();
    }
    this.formGroup.get('status').setValue(this.statuses[0]);
  }
}

const INITIAL_OPTIONS = {
	web_filter: {
		limit: 50,
		offset: 0,
    keyword: "",
    order_by: "asc",
		is_asc: 1
	}
}